import { render, staticRenderFns } from "./WikiEditor.vue?vue&type=template&id=c16bd104"
import script from "./WikiEditor.vue?vue&type=script&lang=js"
export * from "./WikiEditor.vue?vue&type=script&lang=js"
import style0 from "./WikiEditor.vue?vue&type=style&index=0&id=c16bd104&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports